import { render, staticRenderFns } from "./PluginCampaignsList.vue?vue&type=template&id=490182b3&scoped=true"
import script from "./PluginCampaignsList.vue?vue&type=script&lang=js"
export * from "./PluginCampaignsList.vue?vue&type=script&lang=js"
import style0 from "./PluginCampaignsList.vue?vue&type=style&index=0&id=490182b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490182b3",
  null
  
)

export default component.exports